import $ from 'jquery';
import barba from '@barba/core';
import { gsap } from 'gsap';

import { replaceBodyClasses, scrollPosition, enableBodyScroll, wait } from '../global/helpers';
import { $Elements, Events, Classes, Elements, Durations, BarbaLinks, resetAnimations } from '../global/constants';

// ---------- Barba Initialisation ----------

barba.init({
	debug: false,
	timeout: 10000,
	preventRunning: true,
	prevent: ({ el }) => !$(el).is(BarbaLinks),
	transitions: [{
		sync: true,
		once: async() => $Elements.window.on('load', pageLoaded),
		enter: async() => $Elements.document.one(Events.page.transition, pageLoaded),
		leave: async(data) => {

			Elements.LoadingBar.classList.add(Classes.loading);
			Elements.LoadingOverlay.classList.add(Classes.loading);
			document.body.classList.add(Classes.leaving);
			data.current.container.classList.add(Classes.leaving);

			await defaultTransition(data);

			return true;
		},
		after: async(data) => {

			window.scrollTo(0, 0);

			replaceBodyClasses(data.next);

			$('.' + Classes.transitionClone).remove();

			$Elements.document.trigger(Events.page.transition);

			return true;
		}
	}]
});

// ---------- Transitions ----------

async function defaultTransition(data) {

	Elements.LoadingOverlay.classList.add(Classes.loading);

	await wait(Durations.page.ms / 2);

	const scroll = scrollPosition();
	data.next.container.style.top = scroll.scrollTop + 'px';

	if(document.body.classList.contains(Classes.menuOpen)) {
		document.body.classList.remove(Classes.menuOpen);
		enableBodyScroll();
	}

	await wait(Durations.page.ms / 2);

	gsap.set(data.current.container, { opacity: 0 });

	await wait(100);

	window.scrollTo(0, 0);
	data.next.container.style.top = 0;

	return true;
}

async function pageLoaded() {

	resetAnimations();
	gsap.set(document.body, { backgroundColor: null });
	$Elements.document.trigger(Events.page.enter);
	Elements.MainWrapper.classList.remove(Classes.loading, Classes.initialLoad);
	Elements.LoadingBar.classList.remove(Classes.loading);
	Elements.LoadingOverlay.classList.remove(Classes.loading);

	return true;
}
